<template>
  <div class="voice-container">
    <answer-render ref="answer" :config="config">
      <div slot="body">
        <div class="input-wrapper">
          <FormItem prop="value" ref="textContent" :rules="rules">
            <Input
              v-if="config.answerConfig.useText === '1' || windowType === 'pc'"
              class="textarea wyb"
              v-model="openAnswer"
              :placeholder="config.displayPlaceholder"
              type="textarea"
              :rows="config.answerConfig.inputSize"
              :maxlength="1000"
              @on-change="changeOpenAnswer"
            />
          </FormItem>
        </div>
        <RecordVoice :primaryColor="primaryColor" @ok="confirmRecord" :cvtLang="cvtLang" :config="config" :diabled="audiosList.length === 5"></RecordVoice>
        
        <AudioComponent 
          :primaryColor="primaryColor"
          :audioData="audioItem"
          :cvtLang="cvtLang"
          :config="config"
          v-for="(audioItem,audioIndex) in audiosList" 
          :key="audioItem.uid"
          :ref="'audio_'+audioItem.uid"
          @remove="(audioItem) => handleRemove(audioItem, audioIndex)"
          @play="handlePlay"
        ></AudioComponent>

        <div v-if="(config.answerConfig.useText !== '1' && windowType === 'mobile' && openAnswer)" class="extra-info">
          {{ openAnswer }}
        </div>
      </div>
    </answer-render>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import answerValidate from './answerValidate'
import RecordVoice from './components/RecordVoice.vue'
import AudioComponent from './components/AudioComponent.vue'
import uploadFileClient from '@/components/editor/UploadFileBox/uploadFile.js'
import remove from 'loadsh/remove'
import cloneDeep from 'loadsh/cloneDeep'
import { getRandomString } from '@/utils'
import bus from '@/utils/bus'

export default {
  name: 'MusicBoxAnswer',
  props: ['config'],
  data () {
    const {config: { answerConfig: { requireInd } }, cvtLang, getSurveyInfoLang } = this
    return {
      primaryColor: '#45BAA3',

      inited: false,
      otherInfoCache: {}, // 音频文件其他信息的缓存 key为文件的uuid，value对应音频文件的其他信息
      audiosList: [], // 音频列表
      openAnswer: '', // 文本输入框model

      rules: [
        {
          validator: (rule, value, callback) => {
            const errors = answerValidate.validate.bind(this.config)(this).errors
            if (errors.length) {
              return callback(errors)
            }
            return callback()
          }
        }
      ]
    }
  },
  components: {
    RecordVoice,
    AudioComponent
  },
  watch: {
    'answerStyleConfig.button': {
      deep: true,
      immediate: true,
      handler(nv) {
        const { btnColor } = nv;
        this.primaryColor = btnColor;
      }
    }
  },
  computed: {
    ...mapState({
      windowType: ({Question}) => Question.windowType,
      surveyInfoLang: ({Question}) => Question.surveyInfoLang, // 基础语言配置（提示文字、按钮、题型）
      lang: ({Question}) => Question.lang,
      langMap: ({Question}) => Question.langMap,
      answerStyleConfig: ({Question}) => Question.answerStyleConfig,
    })
  },
  created(){
    // 离线app相关 -- 监听事件中心文件写入后的回调 - TODO: 返回的file对象必须包含url
    window._env_ === 'android' && bus.$on(`saveAudioSuccess_${this.config.id}`, this.saveAudioSuccess)
  },
  beforeDestroy(){
    // 离线app相关 -- 移除事件中心文件写入后的回调 - TODO: 返回的file对象必须包含url
    window._env_ === 'android' && bus.$off(`saveAudioSuccess_${this.config.id}`, this.saveAudioSuccess)
  },
  methods: {
    renderAnswer () {
      this.audiosList = []
      const values = cloneDeep(this.config.value)
      
      for(let i = 0;i < values.length;i++){
        if(values[i].openAnswer){
          this.openAnswer = values[i].openAnswer
        }else{
          this.audiosList.push({
            ...values[i]
          })
        }
      }
    },
    // TODO 引用/继承
    isOrigin () {
      return this.lang === 'origin'
    },
    // TODO 引用/继承
    cvtLang: function (id, title) {
      if (this.isOrigin()) {
        return title
      }
      const {lang, langMap} = this
      const key = `${id}_${lang}`
      const value = langMap[key]
      if (!value) {
        this.$set(langMap, key, '')
      }
      return langMap[key]
    },
    getSurveyInfoLang: function () {
      return this.surveyInfoLang
    },

    changeOpenAnswer(v){
      let changeIndex = -1
      this.config.value.map((v, vI) => {
        if(!v.url){
          changeIndex = vI
        }
      })

      if(changeIndex === -1){
        this.config.value.push({
          openAnswer: this.openAnswer
        })
      }else{
        this.$set(this.config.value, changeIndex, {
          openAnswer: this.openAnswer
        })
      }
    },

    // 确认音频记录
    confirmRecord({ src, blob, duration }){
      if(duration < 1000){
        this.$Message.warning(this.cvtLang('tipsRecordTime', this.config.tipsRecordTime))
        return
      }
      
      const file = new File([blob], 'voice.mp3', { type: 'audio/mp3', lastModified: Date.now() });
      this.uploadAction(file, { src, blob, duration })
    },

    // 上传action
    uploadAction(uploadFile, otherInfo){
      const that = this;

      if (window._env_ === 'android') {
        // 离线app相关 -- android app下
        const fileUuid = getRandomString()
        this.$set(this.otherInfoCache, [fileUuid], otherInfo)
        
        /**
         * TODO:
         *  --将文件写入app
         */
        H5Expand.saveFileToLocal({file: uploadFile, questionId: this.config.id, uid: fileUuid,})
      } else {
        uploadFileClient.uploadFile([uploadFile], this, function (file) {
          if (file.url) {
            // 多文件上传时会多次调用
            that.uploadSuccess(file, otherInfo)
          }
        })
      }
    },
    // 离线app相关 -- app文件写入口保存成功
    saveAudioSuccess({ file, uid }){
      const otherInfo = this.otherInfoCache[uid]
      this.uploadSuccess({
        url: file.url,
        uid,
      }, {
        duration: otherInfo.duration
      })

      delete this.otherInfoCache[uid]
    },
    // 上传成功
    uploadSuccess(file, { duration }){
      const { url, key, uid} = file

      const fileObj = {
        url,
        length: duration,
        uid,
      }

      this.config.value.push(fileObj)
      this.audiosList.push(fileObj)
    },

    // 移除文件
    handleRemove(file, i) {
      this.audiosList.splice(i, 1)

      remove(this.config.value, function (item) {
        return item.uid === file.uid
      })
    },

    // 播放事件
    handlePlay(file){
      this.audiosList.map((item) => {
        if(file.uid !== item.uid){
          this.$refs['audio_'+item.uid] && this.$refs['audio_'+item.uid][0] && this.$refs['audio_'+item.uid][0].pauseAudio()
        }
      })
    },

  },
  mounted () {
    this.$nextTick(() => {
      this.renderAnswer()
    })
  }
}
</script>
<style lang="scss" scoped>
 
.input-wrapper {
  .input-answer {
    height: 64px;
    padding: 0 20px;
    line-height: 64px;
    width: 320px;
    outline: none;
    border: 1px solid #C2C2C2;
    border-radius: 4px;

    font-size: 28px;
    font-weight: 500;
  }
  .ivu-input-wrapper {
    margin-top: 40px !important;
  }
}

.extra-info{
  font-weight: 400;
  font-size: 28px;
  line-height: 40px;
  width: 100%;
  padding: 5px*2 12px*2;
  background: #F5F7FA;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 16px;
}

.answer-pc {
  .input-wrapper {
    .ivu-input-wrapper {
      margin-top: 10px !important;
    }
    .input-answer {
      height: 32px;
      padding: 0 10px;
      line-height: 32px;
      width: 160px;
      border-radius: 2px;
      font-size: 14px;
    }
  }
  
  .extra-info{
    display: block;
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    color: rgba(0, 0, 0, 0.45);
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/editor/MusicBox/MusicBoxAnswer.vue